export class TemplateStructureStreamError extends Error {
  constructor(
    public readonly code: string,
    public readonly targetVersionControlId: string,
    message?: string
  ) {
    super(message ?? code);
    this.name = 'TemplateStructureStreamError';
  }
}
